<template>
  <div class="flow-list">
    <div class="list-box">
      <div class="flow-item" v-for="item in flowList" :key="item.step">
        <img class="flow-img" :src="item.img" alt="" />
        <div class="flow-name">{{ item.name }}</div>
        <div class="flow-desc">{{ item.desc }}</div>
        <div class="flow-step">{{ item.step }}</div>
      </div>
    </div>
    <div class="help-title">接入帮助：</div>
    <div class="link-box">
      入驻平台前请先联系商务，<a class="contact-btn" href="https://open.huolala.cn/#/generic-doc/1?menu=1&id=26">获取联系方式</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let flowList = Object.freeze([
      {
        step: 1,
        name: '联系商务',
        desc: '注册前请先联系商务',
        img: require('../../assets/img/index/flow/flow-register.png'),
      },
      {
        step: 2,
        name: '注册',
        desc: '注册并登录开发者账号',
        img: require('../../assets/img/index/flow/flow-register.png'),
      },
      {
        step: 3,
        name: '创建应用',
        desc: '进入控制台创建应用',
        img: require('../../assets/img/index/flow/flow-create.png'),
      },
      {
        step: 4,
        name: '提交应用申请',
        desc: '申请Key',
        img: require('../../assets/img/index/flow/flow-apply.png'),
      },
      {
        step: 5,
        name: '用户授权',
        desc: '申请用户授权',
        img: require('../../assets/img/index/flow/flow-auth.png'),
      },
      {
        step: 6,
        name: '发起调用',
        desc: '发起接口调用',
        img: require('../../assets/img/index/flow/flow-api.png'),
      },
    ]);
    return {
      flowList: flowList,
    };
  },
};
</script>

<style lang="scss" scoped>
.flow-list {
  margin-top: 48px;
}
.contact-btn{
  display: inline-block;
  width: 120px;
  margin-left: -2px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #ff5a00;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    box-shadow: 2px 2px 0 #9e3b05;
  }
}
.list-box {
}
.flow-item {
  display: inline-block;
  width: 184px;
  height: 191px;
  padding-top: 25px;
  margin-right: 18px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  box-sizing: border-box;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    transform: scale(1.1);
  }
}
.flow-img {
  width: 46px;
  height: 45px;
  vertical-align: top;
}
.flow-name {
  font-size: 20px;
  line-height: 20px;
  color: #424456;
  margin-top: 25px;
}
.flow-desc {
  font-size: 12px;
  line-height: 12px;
  color: #424456;
  margin-top: 12px;
}
.flow-step {
  position: absolute;
  bottom: -19px;
  left: 50%;
  margin-left: -19px;
  width: 38px;
  height: 38px;
  line-height: 38px;
  font-size: 24px;
  color: #fff;
  background: #f16222;
  text-align: center;
  border-radius: 19px;
}
.help-title {
  margin-top: 70px;
  color: #f16622;
  font-size: 16px;
}
.link-box {
  margin-top: 10px;
  color: #000;
  font-size: 16px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/flow.vue